export default __webpack_public_path__ + "static/media/tarjetas_aceptadas.c24e48bb.png";